/**
 * Cart footer helpers
 *
 * add / remove a product from cart by variant ID
 * coupon apply/remove and discount display)
 *
 *
 * Example:
 *   AddToCartByVariantId.add('56074754261257');
 *   AddToCartByVariantId.remove('56074754261257');
 */
(function () {
    var cartApi = window.CartApi;

    /* -------------------------------
     * ADD
     * ------------------------------- */
    function add(variantId, options) {
        if (!variantId) return Promise.reject(new Error('Variant ID is required'));
        if (!cartApi || !cartApi.addItem) return Promise.reject(new Error('Cart API unavailable'));
        var opts = options || {};

        return cartApi.addItem(variantId, { quantity: opts.quantity, properties: opts.properties })
            .then(function (result) {
                if (opts.reload !== false) location.reload();
                return result;
            });
    }

    function addIfMissing(variantId, options) {
        var opts = options || {};
        if (!cartApi || !cartApi.fetchCart) return add(variantId, opts);

        return cartApi.fetchCart().then(function (cart) {
            var alreadyInCart = (cart.items || []).some(function (item) {
                return String(item.variant_id) === String(variantId);
            });

            if (alreadyInCart) {
                return { alreadyPresent: true };
            }

            return add(variantId, Object.assign({}, opts, { reload: opts.reload })).then(function (result) {
                return Object.assign({ alreadyPresent: false }, result);
            });
        });
    }

    /* -------------------------------
     * REMOVE
     * ------------------------------- */

    // Removes the FIRST line item matching the variant ID
    function remove(variantId, options) {
        if (!variantId) return Promise.reject(new Error('Variant ID is required'));
        if (!cartApi || !cartApi.fetchCart || !cartApi.changeLineByKey) return Promise.reject(new Error('Cart API unavailable'));
        var opts = options || {};

        return cartApi.fetchCart().then(function (cart) {
            var line = (cart.items || []).find(function (item) {
                return String(item.variant_id) === String(variantId);
            });

            if (!line) {
                return { removed: false, reason: 'not_in_cart' };
            }

            return cartApi.changeLineByKey(line.key, 0).then(function () {
                if (opts.reload !== false) location.reload();
                return { removed: true, variantId: variantId };
            });
        });
    }

    // Removes ONLY if present (clean UX)
    function removeIfPresent(variantId, options) {
        return remove(variantId, options).catch(function () {
            return { removed: false, reason: 'error' };
        });
    }

    /* -------------------------------
     * EXPORTS
     * ------------------------------- */
    window.AddToCartByVariantId = {
        add: add,
        addIfMissing: addIfMissing,
        remove: remove,
        removeIfPresent: removeIfPresent
    };
})();

(function () {
    var giftVariantId = '56074754261257';
    var qualifyingTypes = ['Hot Tub', 'Config'];
    var cleanupInFlight = false;
    var cleanupPending = false;
    var cleanupTimer = null;

    function getSafeCart() {
        return fetch('/cart.js?ts=' + Date.now(), { cache: 'no-store' }).then(function (response) {
            if (!response.ok) throw new Error('Unable to load cart.');
            return response.json();
        });
    }

    function shouldKeepGift(cart) {
        return (cart.items || []).some(function (item) {
            return qualifyingTypes.indexOf(item.product_type) !== -1;
        });
    }

    function giftInCart(cart) {
        return (cart.items || []).some(function (item) {
            return String(item.variant_id) === String(giftVariantId);
        });
    }

    function removeGift(cart) {
        var line = (cart.items || []).find(function (item) {
            return String(item.variant_id) === String(giftVariantId);
        });
        if (!line) return Promise.resolve({ removed: false, reason: 'not_in_cart' });

        return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 })
        })
            .then(function (response) {
                if (!response.ok) throw new Error('Unable to remove gift item.');
                if (window.CartApi && window.CartApi.invalidateCart) window.CartApi.invalidateCart();
                return { removed: true, variantId: giftVariantId };
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    }

    function cleanupGiftIfNeeded(cartOverride) {
        if (cleanupInFlight) {
            cleanupPending = true;
            return;
        }
        cleanupInFlight = true;

        var cartPromise = cartOverride ? Promise.resolve(cartOverride) : getSafeCart();
        cartPromise
            .then(function (cart) {
                var keepGift = shouldKeepGift(cart);
                var hasGift = giftInCart(cart);
                if (keepGift) return null;
                if (!hasGift) return null;
                return removeGift(cart);
            })
            .then(function (result) {
                if (result && result.removed) {
                    window.location.reload();
                }
            })
            .catch(function (error) {
                console.warn('Gift cleanup failed', error);
            })
            .finally(function () {
                cleanupInFlight = false;
                if (cleanupPending) {
                    cleanupPending = false;
                    cleanupGiftIfNeeded();
                }
            });
    }

    function scheduleCleanup(delay) {
        if (cleanupTimer) clearTimeout(cleanupTimer);
        cleanupTimer = setTimeout(function () {
            cleanupGiftIfNeeded();
        }, typeof delay === 'number' ? delay : 400);
    }

    document.addEventListener('DOMContentLoaded', function () {
        cleanupGiftIfNeeded();
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
                if (event && event.cartData) {
                    cleanupGiftIfNeeded(event.cartData);
                    return;
                }
                cleanupGiftIfNeeded();
            });
        }

        document.addEventListener('click', function (event) {
            if (event.target.closest('cart-remove-button')) {
                scheduleCleanup(800);
            }
        });

        document.addEventListener('change', function (event) {
            if (event.target.closest('cart-items') && event.target.name === 'updates[]') {
                scheduleCleanup(800);
            }
        });
    });
})();

(function () {
    document.addEventListener('DOMContentLoaded', function () {
        var couponWrapper = document.querySelector('.coupon-code-wrapper');
        if (!couponWrapper) return;

        var footerConfig = window.CartFooterConfig || {};
        var couponInput = couponWrapper.querySelector('#coupon-code');
        var applyButton = couponWrapper.querySelector('#apply-coupon');
        var couponErrors = document.getElementById('coupon-errors');
        var activeList = document.getElementById('active-discount-list');
        var discountStatusMessage = document.getElementById('discount-status-message');
        var couponNotification = document.getElementById('coupon-notification');
        var redirectPath = '/cart';
        var attemptedDiscountKey = 'lastAttemptedDiscountCode';
        var scrollToCouponKey = 'scrollToCouponAfterRedirect';
        var giftCode = 'headrest2gift';
        var giftVariantId = '56074754261257';
        var removeAllButton = document.getElementById('remove-all-coupons');
        var removeAllLabel = removeAllButton ? (removeAllButton.getAttribute('data-remove-label') || removeAllButton.textContent) : '';

        if (removeAllButton) removeAllButton.style.display = 'none';

        function setError(message, useHtml) {
            if (!couponErrors) return;
            if (useHtml) {
                couponErrors.innerHTML = message || '';
            } else {
                couponErrors.textContent = message || '';
            }
        }

        function normalizeCode(value) {
            return (value || '').trim().toLowerCase();
        }

        function getSafeCart(options) {
            if (window.CartApi && window.CartApi.fetchCart) {
                return window.CartApi.fetchCart(options);
            }
            return fetch('/cart.js').then(function (response) {
                if (!response.ok) throw new Error('Unable to load cart.');
                return response.json();
            });
        }

        function isVariantInCart(variantId) {
            return getSafeCart().then(function (cart) {
                return (cart.items || []).some(function (item) {
                    return String(item.variant_id) === String(variantId);
                });
            });
        }

        function persistAttempt(code) {
            try {
                localStorage.setItem(attemptedDiscountKey, code);
                localStorage.setItem(scrollToCouponKey, 'true');
            } catch (e) {
                console.warn('Unable to persist attempted discount code', e);
            }
        }

        function applyDiscount() {
            var code = couponInput && couponInput.value ? couponInput.value.trim() : '';
            if (!code) return;

            setError('');
            if (normalizeCode(code) === giftCode) {
                isVariantInCart(giftVariantId)
                    .then(function (alreadyInCart) {
                        if (alreadyInCart) {
                            setError(footerConfig.giftAlreadyInCart || 'Gift item is already in your cart.');
                            return null;
                        }
                        return window.AddToCartByVariantId.add(giftVariantId, { reload: false });
                    })
                    .then(function (result) {
                        if (result === null) return;
                        persistAttempt(code);
                        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectPath);
                    })
                    .catch(function (err) {
                        console.error('Unable to add gift variant', err);
                        setError('Unable to add gift to cart. Please try again.');
                    });
                return;
            }

            persistAttempt(code);
            window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectPath);
        }

        function clearDiscounts() {
            if (window.CartApi && window.CartApi.updateCart) {
                return window.CartApi.updateCart({ discount: '' }).catch(function () {
                    return null;
                });
            }
            return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: '' })
            }).catch(function () { return null; });
        }

        function buildDiscountRedirect(codes) {
            var safeCodes = (codes || []).filter(Boolean);
            var url = redirectPath;

            for (var i = safeCodes.length - 1; i >= 0; i -= 1) {
                url = '/discount/' + encodeURIComponent(safeCodes[i]) + '?redirect=' + encodeURIComponent(url);
            }

            return url;
        }

        function redirectWithCodes(codes) {
            var safeCodes = (codes || []).filter(Boolean);
            if (safeCodes.length === 0) {
                clearDiscounts().then(function () { location.reload(); });
                return;
            }

            var targetUrl = buildDiscountRedirect(safeCodes);

            clearDiscounts()
                .then(function () { window.location.href = targetUrl; })
                .catch(function () { window.location.href = targetUrl; });
        }

        function removeDiscountCode(codeToRemove) {
            var target = normalizeCode(codeToRemove);
            getActiveDiscounts()
                .then(function (codes) {
                    var remaining = (codes || []).filter(function (entry) {
                        var entryCode = normalizeCode(entry.code || entry.label);
                        return entryCode && entryCode !== target;
                    });
                    var remainingCodes = remaining
                        .map(function (entry) { return entry.code; })
                        .filter(Boolean);
                    redirectWithCodes(remainingCodes);
                })
                .catch(function (err) {
                    console.error('Unable to remove discount', err);
                });
        }

        function getActiveDiscounts() {
            return getSafeCart().then(function (cart) {
                var codeMap = {};

                function addDiscount(app) {
                    if (!app) return;
                    var code = app.code || app.title;
                    var label = app.title || app.code || code;
                    if (!code && !label) return;
                    var key = normalizeCode(code || label);
                    if (!key) return;
                    if (!codeMap[key]) {
                        codeMap[key] = { code: code || label, label: label };
                    }
                }

                (cart.items || []).forEach(function (item) {
                    (item.line_level_discount_allocations || []).forEach(function (alloc) {
                        addDiscount(alloc.discount_application);
                    });
                });

                (cart.cart_level_discount_applications || []).forEach(function (app) {
                    addDiscount(app);
                });

                return Object.keys(codeMap).map(function (key) { return codeMap[key]; });
            });
        }

        function hasGiftDiscount(codes) {
            return (codes || []).some(function (entry) {
                var code = entry && (entry.code || entry.label);
                return normalizeCode(code) === giftCode;
            });
        }

        function removeGiftProduct() {
            if (!window.AddToCartByVariantId || !window.AddToCartByVariantId.remove) {
                return Promise.resolve();
            }
            return window.AddToCartByVariantId.remove(giftVariantId, { reload: false }).catch(function (err) {
                console.warn('Unable to remove gift product', err);
                return null;
            });
        }

        function handleRemoveAllDiscounts() {
            return getActiveDiscounts()
                .then(function (codes) {
                    var maybeRemoveGift = hasGiftDiscount(codes) ? removeGiftProduct() : Promise.resolve();
                    return maybeRemoveGift.then(function () {
                        redirectWithCodes([]);
                    });
                })
                .catch(function (err) {
                    console.warn('Unable to check active discounts before removal', err);
                    redirectWithCodes([]);
                });
        }

        function renderDiscounts(codes) {
            if (!couponNotification) return;
            if (activeList) activeList.innerHTML = '';

            if (!codes || codes.length === 0) {
                couponNotification.style.display = 'none';
                if (discountStatusMessage) discountStatusMessage.textContent = '';
                return;
            }

            couponNotification.style.display = 'flex';
            codes.forEach(function (entry) {
                if (!activeList) return;
                var code = entry && (entry.code || entry.label) || '';
                var label = entry && entry.label || code;
                var li = document.createElement('li');
                li.className = 'discount-remove-item';
                var iconWrapper = document.createElement('span');
                iconWrapper.className = 'discount-icon';
                iconWrapper.innerHTML = footerConfig.iconDiscount || '';

                var codeWrapper = document.createElement('span');
                codeWrapper.className = 'discount-code';
                codeWrapper.textContent = label;

                li.appendChild(iconWrapper);
                li.appendChild(codeWrapper);
                activeList.appendChild(li);
            });

            if (activeList) {
                var liRemove = document.createElement('li');
                liRemove.className = 'discount-remove-item remove-all-discounts';
                var btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'discount-remove';
                var safeRemoveLabel = (removeAllLabel && removeAllLabel.trim()) || 'Remove discounts';
                btn.setAttribute('aria-label', safeRemoveLabel);
                if (footerConfig.iconCross) {
                    btn.innerHTML = footerConfig.iconCross + '<span class="visually-hidden">' + safeRemoveLabel + '</span>';
                } else {
                    btn.textContent = safeRemoveLabel;
                }
                btn.addEventListener('click', function (event) {
                    event.preventDefault();
                    handleRemoveAllDiscounts();
                });
                liRemove.appendChild(btn);
                activeList.appendChild(liRemove);
            }
        }

        function logInvalidDiscount(attemptedCode, activeCodes) {
            if (!attemptedCode) return;
            var normalizedAttempt = attemptedCode.trim().toLowerCase();
            var found = (activeCodes || []).some(function (entry) {
                var code = entry && (entry.code || entry.label);
                return code && code.trim().toLowerCase() === normalizedAttempt;
            });

            if (!found) {
                var messagePrefix = footerConfig.invalidPrefix || 'Discount code could not be applied: ';
                setError(messagePrefix + '<span class="attempted-coupon-code">' + attemptedCode + '</span>', true);
            } else {
                setError('');
            }

            try {
                localStorage.removeItem(attemptedDiscountKey);
                localStorage.removeItem(scrollToCouponKey);
            } catch (e) {
                console.warn('Unable to clear attempted discount code', e);
            }
        }

        function getAttemptedDiscountCode() {
            var code = null;
            var discountParams = new URLSearchParams(window.location.search);
            code = discountParams.get('discount') || discountParams.get('discount_code');

            if (code) return code;

            try {
                code = localStorage.getItem(attemptedDiscountKey);
            } catch (e) {
                console.warn('Unable to read attempted discount code', e);
            }

            return code;
        }

        var attemptedDiscountCode = getAttemptedDiscountCode();

        function maybeScrollToCoupon() {
            var shouldScroll = false;

            try {
                shouldScroll = localStorage.getItem(scrollToCouponKey) === 'true';
            } catch (e) {
                console.warn('Unable to read scroll flag', e);
            }

            if (!shouldScroll && attemptedDiscountCode) {
                shouldScroll = true;
            }

            if (shouldScroll && couponWrapper) {
                couponWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
                try {
                    localStorage.removeItem(scrollToCouponKey);
                } catch (e) {
                    console.warn('Unable to clear scroll flag', e);
                }
            }
        }

        if (applyButton) {
            applyButton.addEventListener('click', function (event) {
                event.preventDefault();
                applyDiscount();
            });
        }

        if (couponInput) {
            couponInput.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    applyDiscount();
                }
            });
        }

        if (removeAllButton) {
            removeAllButton.addEventListener('click', function (event) {
                event.preventDefault();
                handleRemoveAllDiscounts();
            });
        }

        getActiveDiscounts()
            .then(function (codes) {
                renderDiscounts(codes);
                logInvalidDiscount(attemptedDiscountCode, codes);
                maybeScrollToCoupon();
                if (window.CartApi && window.CartApi.invalidateCart) window.CartApi.invalidateCart();
            })
            .catch(function (error) {
                console.error('Error fetching discounts', error);
                if (discountStatusMessage) discountStatusMessage.textContent = 'Unable to load discount codes.';
            });
    });
})();
